import { render } from "./ExpertChatInput.vue?vue&type=template&id=2ea14a6b&scoped=true"
import script from "./ExpertChatInput.vue?vue&type=script&lang=js"
export * from "./ExpertChatInput.vue?vue&type=script&lang=js"

import "./ExpertChatInput.vue?vue&type=style&index=0&id=2ea14a6b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea14a6b"]])

export default __exports__